// src/components/achievements/MostGoalsScored.js
import React, { useEffect, useState } from 'react';
import NavLink from './../common/NavLink';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
} from '@mui/material';

const MostGoalsScored = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/achievements/most-goals-scored?limit=100`)
      .then((res) => res.json())
      .then((fetchedData) => {
        setData(fetchedData);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Błąd pobierania danych:', err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <Box sx={{ textAlign: 'center', py: 8 }}>
        <Typography variant="h6">Ładowanie rankingu...</Typography>
      </Box>
    );
  }

  if (data.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 8 }}>
        <Typography variant="h6">Brak danych do wyświetlenia</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: { xs: '100%', md: 800 }, mx: 'auto', px: { xs: 1, md: 2 }, py: 4 }}>
      <Typography variant="h5" align="center" gutterBottom sx={{ mb: 4, fontWeight: 700 }}>
        Najwięcej bramek strzelonych
      </Typography>

      <TableContainer component={Paper} sx={{ bgcolor: '#1a1a1a', borderRadius: 2, overflow: 'hidden' }}>
        <Table size="dense" sx={{ '& .MuiTableRow-root': { height: { xs: 42, md: 48 } } }}>
          <TableHead>
            <TableRow sx={{ bgcolor: '#111' }}>
              <TableCell align="center" sx={{ color: '#aaa', fontSize: { xs: '0.7rem', md: '0.8rem' }, width: 50 }}>
                Poz.
              </TableCell>
              <TableCell sx={{ color: '#aaa', fontSize: { xs: '0.7rem', md: '0.8rem' } }}>
                Drużyna
              </TableCell>
              <TableCell align="center" sx={{ color: '#aaa', fontSize: { xs: '0.7rem', md: '0.8rem' }, width: 180 }}>
                Liga
              </TableCell>
              <TableCell align="center" sx={{ color: '#aaa', fontSize: { xs: '0.7rem', md: '0.8rem' }, width: 60 }}>
                M
              </TableCell>
              <TableCell align="center" sx={{ color: '#aaa', fontSize: { xs: '0.7rem', md: '0.8rem' }, width: 80 }}>
                Bramki
              </TableCell>
              <TableCell align="center" sx={{ color: '#aaa', fontSize: { xs: '0.7rem', md: '0.8rem' }, width: 90 }}>
                Śr/mecz
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row) => {
              // Formatowanie nazwy ligi
              const leagueDisplay = row.leagueGroup && row.leagueGroup !== 'Brak' && row.leagueGroup !== ''
                ? `${row.leagueName} (${row.leagueGroup})`
                : row.leagueName;

              return (
                <TableRow key={row.teamId} sx={{ '&:hover': { bgcolor: 'rgba(255,255,255,0.05)' } }}>
                  {/* Pozycja */}
                  <TableCell align="center">
                    <Typography fontWeight={700} color="#fff" sx={{ fontSize: { xs: '0.85rem', md: '0.95rem' } }}>
                      {row.rank}.
                    </Typography>
                  </TableCell>

                  {/* Drużyna – link */}
                  <TableCell>
                    <Typography
                      component={NavLink}
                      to={`/team/${row.teamId}`}
                      sx={{
                        color: 'white',
                        fontWeight: 600,
                        fontSize: { xs: '0.8rem', md: '0.9rem' }
                      }}
                    >
                      {row.teamName}
                    </Typography>
                  </TableCell>

                  {/* Liga – link (załóżmy, że masz route /liga/nazwa lub /liga/id – dostosuj) */}
                  <TableCell align="center">
                    <Typography
                      component={NavLink}
                      to={`/liga/${row.competitionId}`} // przykład – dostosuj do realnego route'a
                      sx={{
                        color: '#bbbbbb',
                        fontSize: { xs: '0.7rem', md: '0.85rem' }
                      }}
                    >
                      {leagueDisplay}
                    </Typography>
                  </TableCell>

                  {/* Mecze */}
                  <TableCell align="center">
                    <Typography fontWeight={600} color="#ccc" sx={{ fontSize: { xs: '0.8rem', md: '0.9rem' } }}>
                      {row.matches}
                    </Typography>
                  </TableCell>

                  {/* Bramki – wyróżnione */}
                  <TableCell align="center">
                    <Typography
                      fontWeight={900}
                      color="#4caf50"
                      sx={{
                        fontSize: { xs: '1.0rem', md: '1.1rem' },
                        textShadow: '0 0 6px rgba(76, 175, 80, 0.4)',
                      }}
                    >
                      {row.scored}
                    </Typography>
                  </TableCell>

                  {/* Średnia */}
                  <TableCell align="center">
                    <Typography fontWeight={600} color="#fff" sx={{ fontSize: { xs: '0.8rem', md: '0.9rem' } }}>
                      {row.scoredPerMatch.toFixed(2)}
                    </Typography>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default MostGoalsScored;